import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";

// Create a Context object for authentication
export const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  // Initialize the navigate function for programmatic navigation
  const navigate = useNavigate();

  // State to store user data, initialized from session storage if available
  const [userData, setUserData] = useState(() =>
    sessionStorage.getItem("userData")
      ? JSON.parse(sessionStorage.getItem("userData"))
      : null
  );

  // Function to log out the user
  const logoutUser = () => {
    // Clear user data from state and session storage
    setUserData(null);
    sessionStorage.removeItem("userData");
    // Navigate to the home page after logout
    navigate("/");
  };

  return (
    // Provide authentication context values to child components
    <AuthContext.Provider
      value={{
        logoutUser,
        userData,
        setUserData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
